import React from 'react';
import { FormInput } from 'shards-react';
import { STEEL_MAKER } from '../../../constants';
import type { SteelMaker } from '../../../types/common';

interface FormDomesticProps {
  steelMaker: SteelMaker;
  labelCustomer: string;
  labelDeliveryLocation: string;
  valueCustomer: string;
  valueDeliveryLocation: string;
  invalidCustomer: boolean;
  invalidDeliveryLocation: boolean;
  disabledCustomer: boolean;
  disabledDeliveryLocation: boolean;
  onChangeCustomer: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeDeliveryLocation: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormDomestic = ({
  steelMaker,
  labelDeliveryLocation,
  labelCustomer,
  valueCustomer,
  valueDeliveryLocation,
  invalidCustomer,
  invalidDeliveryLocation,
  disabledCustomer,
  disabledDeliveryLocation,
  onChangeCustomer,
  onChangeDeliveryLocation,
}: FormDomesticProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {/* 需要家 */}
      <label htmlFor="customer">{labelCustomer}</label>
      <FormInput id="customer" className="mb-3" disabled={disabledCustomer} value={valueCustomer} invalid={invalidCustomer} onChange={onChangeCustomer} />
      {/* 受渡場所 */}
      {steelMaker !== STEEL_MAKER.KOBESTEEL && (
        <>
          <label htmlFor="deliveryLocation">{labelDeliveryLocation}</label>
          <FormInput id="deliveryLocation" className="mb-3" disabled={disabledDeliveryLocation} value={valueDeliveryLocation} invalid={invalidDeliveryLocation} onChange={onChangeDeliveryLocation} />
        </>
      )}
    </>
  );
};

export default FormDomestic;
